import dayjs from 'dayjs';
import { ColumnsType } from 'antd/es/table';

interface DataType {
    title: string;
    dataIndex: string;
    end_at: number;
    start_at: number;
}

const handleDurability = (start, end) => {
    const durationInSeconds = dayjs(end).diff(dayjs(start), 'second');
    const hours = Math.floor(durationInSeconds / 3600);
    const minutes = Math.floor((durationInSeconds % 3600) / 60);
    const seconds = durationInSeconds % 60;

    return [hours, minutes, seconds]
        .map(unit => String(unit).padStart(2, '0'))
        .join(':');
};

export const columns: ColumnsType<DataType> = [
    {
        title: 'Название',
        dataIndex: 'title',
    },

    {
        title: 'Длительность',
        render: record => handleDurability(record.start_at, record.end_at),
    },

    {
        title: 'Дата и время начала',
        dataIndex: 'start_at',
        render: date => dayjs(date).format('DD.MM.YYYY HH:mm'),
        defaultSortOrder: 'descend',
        sorter: (a, b) => a.start_at - b.start_at,
    },
];
